import Player from '@vimeo/player'

(function($) {
  const state = {}
  const lightbox = $('.lightbox')
  const lightboxClose = lightbox.find('.lightbox__close')
  const lightboxContent = lightbox.find('.lightbox__content')
  const lightboxNav = lightbox.find('.lightbox__nav')

  const toggleLighbox = () => {
    if (state.navAction) {
      return false
    }

    lightbox.toggleClass('lightbox--show')

    if (lightbox.hasClass('lightbox--show')) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = null
    }
  }

  lightboxClose.on('click', e => {
    state.navAction = false

    toggleLighbox()

    setTimeout(() => {
      state.current = null
      lightboxContent.empty()
      lightboxNav.empty()
    }, 350)
  })

  // Trigger is an element with data-lightbox-url attribute
  $('[data-lightbox-url]').on('click', function(e) {
    e.preventDefault()
    toggleLighbox()
    const lightboxTarget = $(this)
    const url = lightboxTarget.data('lightbox-url')

    // keep track for later
    state.current = lightboxTarget
    state.pagination = generatePrevNext()

    const { pagination } = state

    lightboxContent.load(`${url} .page--project`, () => {
      // unmute and play the vimeo video after loading
      const target = lightboxContent.find('[data-vimeo-id]')
      const player = new Player(target)
      player.play()

      if (pagination.prev.url) {
        lightboxNav.append(`
          <div class="lightbox__nav-prev">
            <span>Prev</span>
            <a href="${pagination.prev.url}" data-direction="prev">
              ${pagination.prev.text}
            </a>
          </div>
        `)
      }

      if (pagination.next.url) {
        lightboxNav.append(`
          <div class="lightbox__nav-next">
            <span>Next</span>
            <a href="${pagination.next.url}" data-direction="next">
              ${pagination.next.text}
            </a>
          </div>
        `)
      }

      // do it in the next frame to make iOS Safari remove tap/click/hover styles
      setTimeout(() => {
        lightboxContent.find('.project-header').after(lightboxNav.clone())
      }, 0)
    })
  })

  // Handle lightbox navigation clicks
  lightboxContent.on('click', '.lightbox__nav a', function(e) {
    e.preventDefault()
    state.navAction = true
    const direction = $(this).data('direction')

    lightboxNav.closest('.lightbox__content-wrap').animate({
      scrollTop: 0
    }, function() {
      lightboxNav.empty()

      // trigger click on the actual new target element
      if (state.pagination[direction] && state.pagination[direction].element) {
        state.pagination[direction].element.trigger('click')
      }
    })
  })

  // figure out what the "prev" and "next" links are
  // based on the clicked element that can be either a grid block
  // or come from the "Play" button
  function generatePrevNext() {
    const nav = {
      prev: {
        url: '',
        text: '',
        element: null,
      },
      next: {
        url: '',
        text: '',
        element: null,
      }
    }

    const element = state.current
    if (!element) {
      return nav
    }

    // when it's a part of grid block
    if (element.hasClass('block')) {
      const prev = element.prev('.block')
      const next = element.next('.block')

      if (prev.length) {
        nav.prev.url = prev.data('lightbox-url')
        nav.prev.text = prev.find('.block__title').text()
        nav.prev.element = prev
      }

      if (next.length) {
        nav.next.url = next.data('lightbox-url')
        nav.next.text = next.find('.block__title').text()
        nav.next.element = next
      }
    }

    // when it's a part of homepage project sections
    if (element.hasClass('project__play') && element.closest('.section--project')) {
      const section = element.closest('.section--project')
      const prev = section.prev('.section--project')
      const next = section.next('.section--project')

      if (prev.length) {
        nav.prev.url = prev.find('.project__play').data('lightbox-url')
        nav.prev.text = prev.find('.project__title').text()
        nav.prev.element = prev.find('.project__play')
      }

      if (next.length) {
        nav.next.url = next.find('.project__play').data('lightbox-url')
        nav.next.text = next.find('.project__title').text()
        nav.next.element = next.find('.project__play')
      }
    }

    return nav
  }
})(jQuery)
